<script setup>

import EmptyCardComponent from "@/components/cards/EmptyCardComponent.vue";
import BasicButtonComponent from "@/components/form/BasicButtonComponent.vue";
import TextInputComponent from "@/components/form/TextInputComponent.vue";
</script>

<template>
  <empty-card-component
    class="p-4 rounded-xl"
    style="backdrop-filter: blur(10px); background-color: #fff9"
  >
    <template #body>
      <form>
        <text-input-component
          id="email"
          :type="`email`"
          name="email"
          placeholder="Email"
          required
          class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
        />
        <basic-button-component
          type="submit"
          class="mt-4 w-full text-lg text-white font-semibold py-3 block ml-auto bg-red-700"
        >
          Send link
        </basic-button-component>
      </form>
    </template>
  </empty-card-component>
</template>

<style scoped>

</style>